import React from 'react'
import img1 from '../../Image/Rectangle 34625569.png'
import '../Home.css'
import { Link, Navigate, useNavigate } from "react-router-dom";


function Expert2() {
    const navigate = useNavigate()
    const backnavi = () => {
        navigate(-1)
    }
    return (
        <div>
            <div className='container-fluid home-banner-div1'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div>
                                <img src={img1} className='img-fluid' alt="" />
                            </div>

                        </div>
                        <div className='col-lg-7 home-banner-col2-div1'>
                            <div className='home-banner-col2-text11'>
                                <h1>What kind of wax are you looking for?</h1>
                                <h4>Select one option</h4>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <div className='home-banner-btn1'>
                                            <Link to='/expertbase'><div className='btn1'>Base Layer</div></Link>
                                        </div>
                                    </div>

                                    <div className='col-lg-8'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/expertsecond"><div className='btn1'>Second  Layer</div></Link>
                                        </div>
                                    </div>

                                    <div className='col-12'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/expertfinal"><div className='btn1'>Final Layer</div></Link>
                                        </div>
                                    </div>


                                </div>

                                <div className='next-btn-div1'>
                                    <Link onClick={backnavi}>
                                        <div className="next-btn1">
                                            <svg
                                                class="mr-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="11"
                                                height="16"
                                                viewBox="0 0 11 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9 14L3 8L9 2"
                                                    stroke="rgba(0, 0, 0, 0.80)"
                                                    stroke-width="4"
                                                    stroke-linecap="round"
                                                />
                                            </svg>{" "}
                                            Back
                                        </div>
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Expert2
